import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Client } from '@app/core/model/client.model';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { VisitasService } from '../../../core/service/visitas.service';
import { ClientService } from '../../../core/service/client.service';
import Swal from 'sweetalert2';
import { finalize } from 'rxjs/operators';
import { ProveedorService } from '@app/core/service/proveedor.service';
import { PagoService } from '@app/core/service/pago.service';
import { PagoIngresoService } from '@app/core/service/pago-ingreso.service';

@Component({
  selector: 'app-create-pagop',
  templateUrl: './create-pagop.component.html',
  styleUrls: ['./create-pagop.component.css']
})
export class CreatePagopComponent implements OnInit {

  pagoForm: FormGroup;
  selectedValue: any;
  cliente: any;
  fecha: any;
  detalle: any;
  cliente_id: any;

  @Input() title: string;
  // @Input() cliente_id: string;
  @Input() estado: boolean;
  isLoading = false;
  todos: number;

  proveedores:any;
  constructor(
    private formBuilder: FormBuilder,
    public activeModal: NgbActiveModal,
    private visitaService: VisitasService,
    private proveedorService: ProveedorService,
    private pagoService:PagoIngresoService
  ) {}

  ngOnInit() {
    this.listarProveedor();
    this.createFrom();
  }

 

  createFrom() {
    console.log('dentro del create');
    this.pagoForm = this.formBuilder.group({
      fecha: ['', Validators.required],
      nro_comprobante: ['', Validators.required],
      monto: ['', Validators.required],
      detalle: ['', Validators.required],
      proveedor_id: ['']
    });
  }
  // getSelectedCliente(event: Client) {
  //   // alert(event);

  //   console.log('Producto Changed: ' + event.cliente_id);
  //   // console.log(JSON.stringify(event));
  //   // this.resetPurchase();
  //   // this.showDiv = null;
  //   // console.log(i);
  //   this.todos = event.cliente_id;
  //   //  this.patchValues(event.producto_id, i);
  //   // this.addressCustomer = event.address;
  // }

  listarProveedor()
  {

  this.proveedorService.getProveedoresHabilitados().subscribe(data => {
      this.proveedores = data;
      console.log('data cliente', this.proveedores);
    });

  }

  registerPago(pagoForm: any) {
   

   this.pagoForm.value.proveedor_id =  pagoForm.proveedor_id.proveedor_id;
    console.log(pagoForm.value);

    if (this.estado === true) {
      this.pagoService
        .update(this.cliente_id, pagoForm)
        .pipe(
          finalize(() => {
            this.pagoForm.markAsPristine();
            this.isLoading = false;
          })
        )
        .subscribe(
          data => {
            Swal.fire(data);
            this.pagoForm.reset();
            this.activeModal.close(data);
          },
          error1 => {
            Swal.fire(error1.error);
          }
        );
    } else {
      this.isLoading = true;
      this.pagoService
        .create(pagoForm)
        .pipe(
          finalize(() => {
            this.pagoForm.markAsPristine();
            this.isLoading = false;
          })
        )
        .subscribe(
          data => {
            Swal.fire("Su registro se guardo correctamente");
            // this.visitaForm.reset();
            this.activeModal.close(data);
            console.log('dataaaa', data);
          },
          error1 => {
            Swal.fire(error1.error);
          }
        );
    }
  }

}
